// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ISsoStatus {
	enabled: boolean;

	$type?: string | undefined;
}
export class SsoStatus {
	constructor(data?: ISsoStatus) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	enabled: boolean = false;

	static $type: string = "CoreApi.Models.View.SsoStatus, ";
	$type?: string | undefined = SsoStatus.$type;
}

